import React, { useEffect, useState } from "react";
import { Card, Col, Row, Spinner, Modal, Button, Toast } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllTest } from "../../redux/GetAllTestSlice";
import { homeData } from "../../redux/HomeSlice";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import { addToCartItem, flyToCart } from "../../utils/cart";

const Package = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categorySlug } = useParams();

  const responseHome = useSelector((state) => state.homeReducer.data);
  const responseHomeLoading = useSelector(
    (state) => state.homeReducer.isLoading,
  );
  const allTestResponse = useSelector((state) => state.getAllTestReducer.data);
  const allTestLoading = useSelector(
    (state) => state.getAllTestReducer.isLoading,
  );

  const [allTest, setAllTest] = useState([]);
  const [homeData2, setHomeData] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");


  const metaTitle = {
    0: "Blood Test in Mohali, Chandigarh & Panchkula | Quick Reports",
    1: "CT Scan in Mohali, Chandigarh & Panchkula | Fast & Accurate.",
    2: "MRI Scan in Mohali, Chandigarh & Panchkula | Kior Healthcare",
    3: "Ultrasound Scan in Mohali, Chandigarh & Panchkula | Fast Reports",
    4: "Digital X-Ray, Mammography & BMD Services in Mohali – Kior Healthcare",
    5: "Health Checkup Packages in Mohali",
    6: "Best Cardiology Test in Mohali – Kior Healthcare",
    7: "ECG Test in Mohali",
  };

  const metaDescription = {
    0: "Need a blood test in Mohali, Chandigarh or Panchkula? Get fast, accurate reports at Kior Healthcare. NABL-certified lab with affordable pricing.",
    1: "Get CT scan in Mohali, Chandigarh & Panchkula at Kior Healthcare. Advanced technology, affordable price & fast reports. Book your scan today.",
    2: "Get an accurate MRI scan in Mohali, Chandigarh & Panchkula at Kior Healthcare. Advanced technology, fast reports & expert radiologists. Book now.",
    3: "Book ultrasound scan in Mohali, Chandigarh & Panchkula at Kior Healthcare. Accurate imaging, pregnancy scans & fast reports by expert radiologists.",
    4: "Digital X-Ray, Mammography & BMD Services in Mohali – Kior Healthcare",
    5: "Health Checkup Packages in Mohali",
    6: "Best Cardiology Test in Mohali – Kior Healthcare",
    7: "ECG Test in Mohali",
  };

  const titleMap = {
    0: "Blood Test in Mohali, Chandigarh & Panchkula – Accurate Reports at Kior Healthcare.",
    1: "Best CT Scan in Mohali, Chandigarh & Panchkula – Advanced CT Imaging at Kior Healthcare",
    2: "Best MRI Scan in Mohali, Chandigarh & Panchkula – Advanced MRI Imaging at Kior Healthcare",
    3: "Best Ultrasound Scan in Mohali, Chandigarh & Panchkula – Kior Healthcare.",
    4: "Digital X-Ray, Mammography & BMD Services in Mohali – Kior Healthcare",
    5: "Health Checkup Packages in Mohali",
    6: "Best Cardiology Test in Mohali – Kior Healthcare",
    7: "ECG Test in Mohali",
  };
  const h1Desc = {
    0: "Searching for a reliable blood test in Mohali, Chandigarh, or Panchkula? Kior Healthcare provides precise and timely diagnostic testing backed by advanced laboratory technology and certified processes. From routine health checkups to specialized investigations, we ensure every report is clinically accurate and delivered on time. Patients across the Tricity trust us for dependable blood testing services with a focus on quality and care.",
    1: "Looking for the best CT scan in Mohali, Chandigarh, or Panchkula? Kior Healthcare offers advanced CT imaging with modern diagnostic technology to deliver fast, accurate, and reliable results. Our centre prioritizes patient safety, comfort, and precise reporting to help doctors make confident medical decisions. Trusted by patients and healthcare professionals across the Tricity, we are a leading choice for CT scans in Mohali, Chandigarh, and Panchkula.",
    2: "Looking for the best MRI scan in Mohali, Chandigarh, or Panchkula? Kior Healthcare offers advanced MRI imaging using modern diagnostic technology to deliver detailed and highly accurate results. Our centre focuses on patient comfort, safe scanning protocols, and precise reporting to support confident clinical decisions. With experienced radiologists and a strong reputation across the Tricity, we are a trusted choice for MRI scans in Mohali, Chandigarh, and Panchkula.",
    3: "Looking for the best ultrasound scan in Mohali, Chandigarh, or Panchkula? Kior Healthcare offers advanced ultrasound imaging with modern diagnostic technology to deliver accurate and safe results. Our centre focuses on patient comfort, precise reporting, and early diagnosis to support effective medical decisions. Trusted by patients and doctors across the Tricity, we are a reliable choice for ultrasound scans in Mohali, Chandigarh, and Panchkula.",
    4: "Kior Healthcare provides Digital X-Ray Scan in Mohali and makes use of the latest radiology equipment that is focused on quick imaging and precise reporting. We, being the reliable diagnostic lab in the Tricity region, provide advanced imaging and laboratory services using up-to-date equipment under the guidance of an experienced radiology team. We use some of the latest technology in digital X-Ray, Mammography, Ultrasound, CT scans, MRI and full computerised lab testing for complete diagnostic care.",
    5: "If you are looking for comprehensive Health Checkup Packages in Mohali, Kior Healthcare offers advanced and affordable screening solutions designed for early disease detection and preventive care. Our packages are tailored for individuals, families, and corporate employees who want to monitor their overall health with accurate and reliable diagnostics. As a modern diagnostic centre with NABL-standard protocols, we ensure precise testing, hygienic sample collection, and timely report delivery.",
    6: "Maintaining a healthy heart starts with accurate diagnosis, and choosing the Best Cardiology Test in Mohali plays a crucial role in early detection and prevention of serious cardiac conditions. Kior Healthcare is a trusted diagnostic centre offering advanced cardiology tests with a strong focus on accuracy, safety, and patient comfort. Our facility is equipped with modern diagnostic technology and follows strict quality protocols to deliver reliable results you can trust. We provide essential heart investigations such as ECG, 2D Echo, TMT (Stress Test), Holter Monitoring, Lipid Profile, and other cardiac screening tests. These tests help identify heart-related issues like blocked arteries, irregular heartbeats, hypertension-related risks, and early signs of heart disease, enabling timely medical intervention.",
    7: "If you are searching for an accurate and reliable ECG Test in Mohali, Kior Healthcare provides advanced cardiac diagnostics with precision and expert supervision. An Electrocardiogram (ECG) measures the electrical activity of the heart and helps detect irregular heartbeat, heart blockages, chest pain causes, and other cardiovascular conditions. Our modern diagnostic centre ensures quick testing, minimal waiting time, and accurate reporting to support timely medical decisions.",
  };

  const h2Title = {
    0: "Modern Pathology Lab in Mohali for Complete Diagnostic Care",
    1: "CT Scan Centre in Mohali with Advanced Diagnostic Technology.",
    2: "Advanced MRI Scan Centre in Mohali with Latest Technology.",
    3: "Advanced Ultrasound Centre in Mohali with Accurate Diagnosis.",
    4: "Digital X-Ray Scan in Mohali – Fast & Accurate Imaging",
    5: "Full Body Test in Mohali",
    6: "Affordable Heart Tests in Mohali",
    7: "EEG Test in Mohali",
  };

  const h2Desc = {
    0: "At Kior Healthcare, our fully equipped pathology lab in Mohali supports a wide spectrum of diagnostic needs. With NABL-certified standards and experienced lab professionals, we maintain strict quality control at every stage—from sample collection to final reporting. People from Chandigarh and Panchkula choose our lab for its consistency, hygiene standards, and efficient service. Whether it’s a routine test or a preventive health package, we ensure a smooth and hassle-free experience.",
    1: "Kior Healthcare is equipped with state-of-the-art CT scan systems designed to diagnose a wide range of conditions, including brain disorders, chest infections, internal injuries, bone fractures, and abdominal issues. As a trusted CT scan centre in Mohali, we ensure every scan is conducted with accuracy, safety, and expert supervision. Patients from Chandigarh and Panchkula also prefer our centre for high-quality and dependable CT imaging services.",
    2: "Kior Healthcare is equipped with state-of-the-art MRI systems designed to diagnose a wide range of conditions, including neurological disorders, spine issues, joint injuries, and internal organ abnormalities. As a leading MRI scan centre in Mohali, we ensure every scan is conducted with precision, safety, and expert supervision. Patients from Chandigarh and Panchkula also prefer our centre for reliable and high-quality MRI imaging services.",
    3: "Kior Healthcare is recognized as a leading ultrasound centre in Mohali, equipped with state-of-the-art imaging technology and experienced radiologists. We specialize in detailed organ analysis, pregnancy monitoring, and early disease detection. Patients from Chandigarh and Panchkula also prefer our centre for high-quality ultrasound imaging with consistent accuracy and care. Our facility offers a complete range of diagnostic services including CT Scan, MRI, Digital X-Ray, Mammography, Ultrasound, and Colour Doppler, supported by a fully computerized system for fast and secure report delivery.",
    4: "Our Digital X-Ray technology provides high-resolution images with reduced radiation exposure and faster report turnaround. It helps diagnose fractures, infections, lung conditions, and joint abnormalities with precision. At Kior Healthcare, every scan is performed using standardized protocols to maintain accuracy and clinical reliability.",
    5: "Our Full Body Test in Mohali includes a comprehensive panel of essential investigations such as CBC, liver function test (LFT), kidney function test (KFT), lipid profile, blood sugar, thyroid profile, and vitamin screening. These tests help assess organ function, detect nutritional deficiencies, and identify early risk factors for chronic conditions like diabetes and heart disease.",
    6: "At Kior Healthcare, we believe quality cardiac care should be accessible to everyone. That’s why we offer Affordable Heart Tests in Mohali without compromising on diagnostic standards. Our transparent pricing, minimal waiting time, hygienic environment, and fast report delivery make us a preferred choice for preventive and diagnostic heart care. Whether you need a routine heart check-up or tests recommended by your doctor, Kior Healthcare is committed to delivering dependable, affordable, and patient-focused cardiology diagnostics for long-term heart health.",
    7: "Along with cardiac diagnostics, we offer specialized EEG tests to monitor brain activity. EEG (Electroencephalogram) is commonly recommended for patients experiencing seizures, epilepsy, migraines, sleep disorders, or neurological symptoms. Our trained professionals ensure safe procedures and reliable results for effective diagnosis and treatment planning.",
  };
  const h22Title = {
    0: "Fast & Reliable Blood Test in Chandigarh and Panchkula (Near You).",
    1: "CT Scan in Chandigarh & Panchkula with Fast and Accurate Reporting.",
    2: "MRI Scan in Chandigarh & Panchkula with Fast and Accurate Reporting.",
    3: "Ultrasound Scan in Chandigarh & Panchkula with Fast Reporting.",
    4: "Mammography Test Near Me – Early Breast Health Screening",
    5: "Preventive Health Checkup in Mohali",
    6: "",
    7: "NCV Test in Mohali",
  };

  const h22Desc = {
    0: "If you're looking for a blood test in Chandigarh or a blood test in Panchkula, our Mohali centre offers quick access with minimal waiting time. We understand the importance of timely diagnosis, which is why we prioritize fast processing and accurate reporting. With streamlined booking and professional handling, Kior Healthcare ensures that patients across Chandigarh, Panchkula, and nearby areas receive dependable results without delays.",
    1: "Searching for a CT scan in Chandigarh or a CT scan in Panchkula? Kior Healthcare in Mohali offers convenient access to advanced imaging services across the Tricity. We provide easy appointment booking, minimal waiting time, and quick report delivery without compromising accuracy. Our experienced radiology team follows strict quality standards to ensure reliable diagnostic results. Patients from Chandigarh, Panchkula, and nearby areas trust us for safe, precise, and timely CT scan services.",
    2: "Searching for an MRI scan in Chandigarh or an MRI scan in Panchkula? Kior Healthcare in Mohali provides convenient access to advanced imaging services for patients across the Tricity. We offer quick appointment booking, minimal waiting time, and fast report delivery without compromising accuracy. Our expert radiology team follows strict quality standards to ensure reliable results, helping doctors make effective treatment decisions. Patients from Chandigarh, Panchkula, and nearby areas trust us for safe, precise, and timely MRI scan services.",
    3: "Searching for an ultrasound scan in Chandigarh or an ultrasound scan in Panchkula? Kior Healthcare in Mohali provides easy access to advanced imaging services across the Tricity. We offer convenient appointment booking, minimal waiting time, and quick, reliable report delivery. Our expert team ensures every scan meets strict quality standards, helping doctors make accurate diagnoses and treatment plans.",
    4: "Kior Healthcare offers Digital X-Ray Scan in Mohali using advanced radiology systems designed for fast imaging and accurate reporting. equipped with an advanced radiology system, providing quick imaging results and accurate reports. Providing Mammography in Mohali by expert doctors with advanced machines. Our advanced mammography technology helps physicians diagnose early, which can lead to less invasive treatments. Mammography is indeed a key screening modality, particularly for women outside of the recommended screening age or who are at higher than average risk.",
    5: "A Preventive Health Checkup in Mohali is crucial for maintaining long-term wellness. Regular health screening supports early diagnosis, reduces medical risks, and enables timely treatment. At Kior Healthcare, we combine advanced technology, accurate diagnostic reports, and patient-focused care—making us a trusted choice for complete health screening in Mohali.",
    6: "",
    7: "We also provide advanced NCV (Nerve Conduction Velocity) testing to evaluate nerve damage and muscle response. This test is essential for diagnosing neuropathy, nerve compression, and other neurological disorders. At Kior Healthcare, we combine advanced technology, NABL-standard protocols, and patient-focused care—making us a trusted diagnostic partner in Mohali.",
  };


  const slugify = (text) =>
    text
      ?.toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/-+/g, "-") || "";

  useEffect(() => {
    dispatch(homeData());
  }, [dispatch]);

  useEffect(() => {
    if (responseHome?.status === 1) {
      const data = responseHome.data;
      const categories = (data?.categories || []).map((c) => ({
        ...c,
        slug: c.slug || slugify(c.name),
      }));
      setHomeData({ ...data, categories });
       const cateSlug = categorySlug==undefined?categorySlug:categorySlug.replace(/-mohali$/, "")
      const selectedBySlug = cateSlug
        ? categories.find(
            (c) => c.slug === cateSlug || c._id === cateSlug,
          )
        : null;

      const defaultCategoryId = selectedBySlug?._id || categories?.[0]?._id;
      if (defaultCategoryId) {
        dispatch(getAllTest(defaultCategoryId));
      }

      const index = categories?.findIndex((c) => c._id === defaultCategoryId);
      console.log("Selected Category Index:", metaDescription[index]);
      setSelectedIndex(index >= 0 ? index : 0); 
    }
  }, [responseHome, categorySlug, dispatch]);

  useEffect(() => {
    if (allTestResponse?.status === 1) {
      setAllTest(allTestResponse.data);
    }
  }, [allTestResponse]);

  const clickOnCategory = (index, cat) => {
    setSelectedIndex(index);
    const slug = cat.slug || slugify(cat.name);
    navigate(`/${slug + "-mohali"}`);
  };

  const addToCart = (item, event) => {
    const isPackageCategory =
      String(categorySlug || "").includes("health-package") ||
      String(categorySlug || "").includes("package");
    const { added } = addToCartItem(item, { isPackage: isPackageCategory });
    const btn = event?.currentTarget;
    if (btn) {
      btn.classList.remove("btn-added-pulse");
      void btn.offsetWidth;
      btn.classList.add("btn-added-pulse");
      flyToCart(btn);
    }
    setToastMsg(
      added
        ? "Added to cart — open cart to checkout"
        : "Already in cart"
    );
    setShowToast(true);
  };

  const openDetails = (item) => {
    setModalData(item);
    setShowModal(true);
  };

  return (
    <>
     <Helmet>
        <title>{metaTitle[selectedIndex]}</title>
        <meta name="description" content={metaDescription[selectedIndex]} />
      </Helmet>

      <div className="package">

        {/* ================= HERO ================= */}
        <div className="package_hero">
          <h1>{titleMap[selectedIndex]}</h1>
          <p>{h1Desc[selectedIndex]}</p>
          {/* </div> */}
        </div>

        {/* ================= DESCRIPTION ================= */}
        <div className="package_description">
          <div className="container">
            <div className="desc_box">
              <h2>{h2Title[selectedIndex]}</h2>
              <p>{h2Desc[selectedIndex]}</p>
              <h2>{h22Title[selectedIndex]}</h2>
              <p>{h22Desc[selectedIndex]}</p>
            </div>
          </div>
        </div>

        {/* ================= PACKAGES ================= */}
        <div className="container package_grid">
          <Row className="g-4 mb-3">
            {responseHomeLoading || allTestLoading ? (
              <div className="text-center w-100 py-5">
                <Spinner animation="border" />
                <p className="mt-2 text-muted">Loading tests...</p>
              </div>
            ) : allTest?.length ? (
              allTest.map((item) => (
                <Col lg={4} md={6} key={item._id}>
                  <Card className="package_card">
                    <Card.Body>
                      <h6 className="title">{item.name}</h6>
                      <div className="price">₹ {item.amount}</div>

                      <div className="actions">
                        <Button
                          className="btn_primary"
                          onClick={(e) => addToCart(item, e)}
                        >
                          Add to Cart
                        </Button>
                        <Button
                          variant="link"
                          className="btn_link"
                          onClick={() => openDetails(item)}
                        >
                          Know More →
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <p className="text-center text-muted py-5">No tests found.</p>
            )}
          </Row>
        </div>

        {/* MODAL */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{modalData?.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{modalData?.description}</p>
            <p>
              <strong>Price:</strong> ₹ {modalData?.amount}
            </p>
          </Modal.Body>
        </Modal>

        {/* TOAST */}
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={2200}
          autohide
          className="cart-toast"
          style={{ position: "fixed", right: 20, bottom: 20, zIndex: 1080 }}
        >
          <Toast.Body>{toastMsg}</Toast.Body>
        </Toast>
      </div>
    </>
  );
};

export default Package;
